import { get, post } from '@/api/request'
import { utilities } from '@billow/js-helpers'

export default {

  store: (task, success, failure) => post(
    `/api/project/${task.project_id}/task`,
    task,
    response => success(response),
    error => failure(error)
  ),

  update: (task, success, failure) => post(
    `/api/tasks/${task.id}`,
    task,
    response => success(response),
    error => failure(error)
  ),

  loadTask: (taskId, success, failure) => get(
    `/api/tasks/${taskId}`,
    response => success(response),
    error => failure(error)
  ),

  storeComment: (payload, success, failure) => post(
    `/api/tasks/${payload.taskId}/comment`,
    payload.comment,
    response => success(response),
    error => failure(error)
  ),

  updateComment: (payload, success, failure) => post(
    `/api/comments/${payload.id}`,
    payload,
    response => success(response),
    error => failure(error)
  ),

  trashComment: (comment, success, failure) => post(
    `/api/comments/${comment}/trash`,
    {}, success, failure
  ),

  storeTodo: (payload, success, failure) => post(
    `/api/tasks/${payload.taskId}/todo`,
    payload,
    response => success(response),
    error => failure(error)
  ),

  updateTodoContent: (payload, success, failure) => post(
    `/api/todo/${payload.id}/content`,
    payload, success, failure
  ),

  close: (taskId, success, failure) => post(
    `/api/tasks/${taskId}/close`,
    {},
    response => success(response),
    error => failure(error)
  ),

  reopen: (taskId, success, failure) => post(
    `/api/tasks/${taskId}/reopen`,
    {},
    response => success(response),
    error => failure(error)
  ),

  assignUser: (payload, success, failure) => post(
    `/api/tasks/${payload.taskId}/user/${payload.userId}/assign`,
    {},
    response => success(response),
    error => failure(error)
  ),

  assignLabel: (payload, success, failure) => post(
    `/api/tasks/${payload.taskId}/label/${payload.labelId}/assign`,
    {},
    response => success(response),
    error => failure(error)
  ),

  unassignUser: (payload, success, failure) => post(
    `/api/tasks/${payload.taskId}/user/${payload.userId}/unassign`,
    {},
    response => success(response),
    error => failure(error)
  ),

  removeLabel: (payload, success, failure) => post(
    `/api/tasks/${payload.taskId}/label/${payload.labelId}/remove`,
    {},
    response => success(response),
    error => failure(error)
  ),

  spendTime: (payload, success, failure) => post(
    `/api/tasks/${payload.taskId}/time`,
    payload.hours,
    response => success(response),
    error => failure(error)
  ),

  updatePriority: (payload, success, failure) => post(
    `/api/tasks/${payload.taskId}/priority`,
    payload,
    response => success(response),
    error => failure(error)
  ),

  updateEstimatedTime: (payload, success, failure) => post(
    `/api/tasks/${payload.taskId}/estimated-time`,
    payload,
    response => success(response),
    error => failure(error)
  ),

  toggleTodoComplete: (todoId, success, failure) => post(
    `/api/todo/${todoId}/toggle-complete`,
    {},
    response => success(response),
    error => failure(error)
  ),

  removeTodo: (todoId, success, failure) => post(
    `/api/todo/${todoId}/remove`,
    {},
    response => success(response),
    error => failure(error)
  ),

  removeTime: (timeId, success, failure) => post(
    `/api/time/${timeId}/remove`,
    {},
    response => success(response),
    error => failure(error)
  ),

  uploadFile: (payload, success, failure) => post(
    `/api/tasks/${payload.taskId}/file`,
    utilities.formData(payload.upload),
    response => success(response),
    error => failure(error)
  ),

  // @todo, move to separate API when other modules use files.
  deleteFile: (file, success, failure) => post(
    `/api/files/${file}/delete`,
    {}, success, failure
  ),

  projectsForTransfer: (task, success, failure) => get(
    `/api/tasks/${task}/transfer/projects`,
    success, failure
  ),

  transfer: ({ task, project }, success, failure) => post(
    `/api/tasks/${task}/transfer/${project}`,
    {}, success, failure
  ),
  
  updateTodosSort: (payload, success, failure) => post(
    `/api/tasks/${payload.taskId}/sort-todos`,
    { todos: payload.todos }, success, failure
  ),
  
  updateMilestone: (payload, success, failure) => post(
    `/api/tasks/${payload.taskId}/milestone`,
    payload, success, failure
  ),

  clearMilestone: (taskId, success, failure) => post(
    `/api/tasks/${taskId}/milestone/clear`,
    {}, success, failure
  ),

}
